module.exports = "/packs/images/svg/menu~cfabe54492f7af82e3b4abfbbe913df4.svg";